import React, { useState } from "react";
import { Stethoscope, Copy, Check } from "lucide-react";
import { collectPushDiagnostics, isAndroidShell } from "../lib/native";
import { isNativeApp } from "../lib/platform";

const ROWS = [
  ["Origin страницы", "origin"],
  ["Платформа", "platform"],
  ["Нативное приложение", "isNative"],
  ["Мост Android (androidBridge)", "androidBridge"],
  ["Плагин PushNotifications", "pluginPush"],
  ["Плагин AppSettings", "pluginSettings"],
  ["Системное разрешение", "permission"],
  ["FCM-токен", "token"],
  ["Тема приложения", "theme"],
  ["Фон страницы", "background"],
  ["Системная тёмная тема", "systemDark"],
  ["Web Notification API", "webNotificationApi"],
  ["User-Agent", "ua"],
];

const fmt = (v) => (v === true ? "да" : v === false ? "нет" : String(v));

/** Диагностика push прямо в приложении — чтобы видеть состояние release-сборки. */
export default function PushDiagnostics() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const visible = isNativeApp() || isAndroidShell() ||
    (typeof window !== "undefined" && window.location.search.includes("diag=push"));
  if (!visible) return null;

  const toggle = async () => {
    if (!open) setData(await collectPushDiagnostics());
    setOpen(!open);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* noop */ }
  };

  return (
    <div style={{ padding: "0 16px 12px" }}>
      <button data-testid="push-diagnostics-toggle" onClick={toggle}
        style={{ width: "100%", background: "transparent", border: "1px solid var(--ang-border)",
          borderRadius: "8px", padding: "11px 14px", cursor: "pointer", display: "flex",
          alignItems: "center", gap: "8px", color: "var(--ang-text-muted)",
          fontFamily: "Manrope", fontSize: "11px", letterSpacing: "0.06em", textTransform: "uppercase" }}>
        <Stethoscope size={14} /> Диагностика уведомлений
      </button>

      {open && data && (
        <div data-testid="push-diagnostics-body"
          style={{ marginTop: "8px", background: "var(--ang-surface)", border: "1px solid var(--ang-border)",
            borderRadius: "8px", padding: "12px 14px" }}>
          {ROWS.map(([label, key]) => (
            <div key={key} style={{ display: "flex", justifyContent: "space-between", gap: "10px",
              padding: "4px 0", borderBottom: "1px solid var(--ang-border)" }}>
              <span style={{ fontFamily: "Manrope", fontSize: "11px", color: "var(--ang-text-muted)" }}>{label}</span>
              <span data-testid={`diag-${key}`} style={{ fontFamily: "Manrope", fontSize: "11px",
                color: "var(--ang-text)", textAlign: "right", wordBreak: "break-all", maxWidth: "60%" }}>
                {fmt(data[key])}
              </span>
            </div>
          ))}
          {data.error && (
            <div style={{ marginTop: "8px", fontFamily: "Manrope", fontSize: "11px", color: "#b4453a" }}>
              {data.error}
            </div>
          )}
          <button data-testid="push-diagnostics-copy" onClick={copy}
            style={{ marginTop: "12px", width: "100%", background: "transparent",
              border: "1px solid var(--ang-gold-line)", borderRadius: "6px", padding: "9px",
              cursor: "pointer", color: "var(--ang-gold)", fontFamily: "Manrope", fontSize: "11px",
              letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 600,
              display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            {copied ? <Check size={13} /> : <Copy size={13} />} {copied ? "Скопировано" : "Скопировать отчёт"}
          </button>
        </div>
      )}
    </div>
  );
}
